const PROD_TURNSTILE_SITE_KEY = '0x4AAAAAADsvVI83LzNbfnaf'
const UAT_TURNSTILE_SITE_KEY = '0x4AAAAAADpgsxWN7P1wjht8'
const TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS = 13000

export const turnstileConfig = {
  prod: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: PROD_TURNSTILE_SITE_KEY,
    timeoutMs: TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
  },
  master: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: UAT_TURNSTILE_SITE_KEY,
    timeoutMs: TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
  },
  dev: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: UAT_TURNSTILE_SITE_KEY,
    timeoutMs: TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
  },
  local: {
    enabled: false,
    enabledProducts: [],
    siteKey: '',
    timeoutMs: TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
  },
}
